import * as types from '../constants/ActionTypes'

let expandVideo = () => {
	return {
		type: types.ENLARGE_VIDEO,
		payload: {}
	}
}

let shrinkVideo = () => {
	return {
		type: types.SHRINK_VIDEO,
		payload: {}
	}
}
let setVideo = (video_display_status) => {
	return {
		type: types.VIDEO_DISPLAY_STATUS,
		payload: {video_display_status}
	}
}
export default {expandVideo, shrinkVideo, setVideo}
